import React, { useEffect, useState } from 'react';
const { richTextFromMarkdown } = require('@contentful/rich-text-from-markdown');
import PropTypes from 'prop-types';

import Button from '$partials/ui/button';
import Logo from '$partials/icons/logo';
import RichText from '$partials/global/rich-text';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const Profile = ({
    avatar,
    description,
    name,
    profileUrl,
    slug
}) => {
    const [text, setText] = useState('');

    useEffect(() => {
        const document = async () => {
            const done = await richTextFromMarkdown(description);
            setText(done);
        };

        if (description) {
            document();
        }
    }, []);

    return (
        <section className='mt-60 relative px-10 sm:px-0'>
            <div className='flex flex-wrap px-w-1/12 sm:px-20 pt-20 pb-90 sm:pb-20 md:py-40 bg-peach md:-mb-40 md:-mx-20 mt-0'>
                <div className='w-full sm:w-6/12 md:w-4/12 flex flex-col md:pl-20 mb-30 sm:mb-0'>
                    <p className='type-style-8'>
                        Written by
                    </p>
                    <a href={`/profiles/${slug}`}>
                        {name}
                    </a>
                </div>
                <div className='w-full sm:w-6/12 flex flex-col sm:pl-20'>
                    {text && <RichText
                        className='rich-text type-style-8 mb-10'
                        json={text} />}
                    <Button
                        as='a'
                        className='flex self-start items-center bg-orange text-white  rounded type-style-7 px-20 py-15'
                        href={profileUrl}
                        renderIcon={<Logo />}>
                        Follow on
                    </Button>
                </div>
            </div>
            <div className='w-[124px] h-[124px] mt-[-62px] ml-w-1/12 sm:ml-20'>
                <a
                    className='w-full h-full block'
                    href={`/profiles/${slug}`}>
                    <div
                        className='bg-cover rounded-full w-full h-full'
                        style={{backgroundImage: `url(${avatar?.src})`}}
                        title={avatar?.title} />
                </a>
            </div>
        </section>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

Profile.propTypes = {
    avatar: PropTypes.shape({
        src: PropTypes.string,
        title: PropTypes.string,
    }),
    description: PropTypes.string,
    name: PropTypes.string,
    profileUrl: PropTypes.string,
    slug: PropTypes.string,
};

export default Profile;
